import { registerDecorator, ValidatorConstraint } from 'class-validator';
import { a as applyDecorators } from './applyDecorators_chunkExport-D6nMF0T1.mjs';
import { isNil } from '@worksolutions/utils';

function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function IsInstancesOf(classes, options) {
    return applyDecorators((object, propertyName)=>registerDecorator({
            name: isInstancesOfValidatorName,
            target: object.constructor,
            options,
            propertyName,
            validator: IsInstancesOfValidator,
            constraints: [
                classes,
                options
            ]
        }));
}
const isInstancesOfValidatorName = "CustomIsInstancesOfValidator";
function getIsInstancesOfSchema() {
    return {};
}
class IsInstancesOfValidator {
    validate(value, { constraints: [classes] }) {
        if (isNil(value)) return true;
        // if (options.each) {
        //   if (!isArray(value)) return false;
        //   return value.every((item) => classes.some((classItem: Constructable<any>) => item instanceof classItem));
        // }
        return classes.some((classItem)=>value instanceof classItem);
    }
}
IsInstancesOfValidator = _ts_decorate([
    ValidatorConstraint({
        name: isInstancesOfValidatorName
    })
], IsInstancesOfValidator);

export { IsInstancesOf as I, getIsInstancesOfSchema as g, isInstancesOfValidatorName as i };
//# sourceMappingURL=isInstanceOf_chunkExport-3TjMkSYs.mjs.map
